<script setup lang="ts">
import DefaultLayout from '~/layouts/default.vue'
</script>

<template>
  <DefaultLayout auth-mode="public">
    <slot />
  </DefaultLayout>
</template>
